import { Sprite, Text } from 'pixi.js';
import SoundList from '../../gamma-engine/common/sound/SoundList';
import { IntroScreenEvent } from '../../gamma-engine/common/view/event/IntroScreenEvent';
import Logo from '../../gamma-engine/common/view/Logo';
import AssetsManager from '../../gamma-engine/core/assets/AssetsManager';
import Sound from '../../gamma-engine/core/sound/Sound';
import SoundManager from '../../gamma-engine/core/sound/SoundManager';
import { Tweener } from '../../gamma-engine/core/tweener/engineTween';
import LayoutBuilder from '../../gamma-engine/core/utils/LayoutBuilder';
import AdjustableLayoutContainer from '../../gamma-engine/core/view/AdjustableLayoutContainer';
import LayoutElement from '../../gamma-engine/core/view/model/LayoutElement';
import { UpdateLayoutDescription } from '../../gamma-engine/core/view/UpdateLayoutDescription';
import IntroScreenBackground from './IntroScreenBackground';

export default class PreIntroScreen extends AdjustableLayoutContainer {

    private logo: Sprite;
    private background: IntroScreenBackground;
    private clickText: Text;
    private backgroundSound: Sound;

    constructor() {
        super(AssetsManager.layouts.get('pre-intro-screen'));
        LayoutBuilder.create(this.layout, this, (le: LayoutElement) => {
            return this.customClassElementCreate(le);
        });
        this.background.eventMode = 'dynamic';
        this.background.cursor = 'pointer'
        this.background.once('click', this.onStageClick, this)
        this.background.once('tap', this.onStageClick, this)

        // document.body.addEventListener('keydown', this.onStageClick.bind(this), { once: true });

        this.on('added', this.onAdded, this)
        this.on('removed', this.onRemoved, this);
    }

    public updateLayout(desc: UpdateLayoutDescription) {
        super.updateLayout(desc);
        this.clickText.pivot.set(0);
    }

    private onRemoved(): void {
        this.background.eventMode = 'none';
        this.background.off('click', this.onStageClick, this)
        this.background.off('tap', this.onStageClick, this)
        Tweener.removeTweens(this);
    }

    private customClassElementCreate(le: LayoutElement): unknown {
        let instance: unknown = null;
        switch (le.customClass) {
            case 'IntroScreenBackground':
                instance = new IntroScreenBackground();
                break;
            case 'Logo':
                instance = new Logo();
                break;
        }

        return instance;
    }
    private onAdded(): void {

    }

    private onStageClick(): void {
        SoundManager.play(SoundList.UI_BUTTON_CLICK);
        this.emit(IntroScreenEvent.ON_GET_STARTED_CLICKED);
    }
}
